import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { ExamesTesteSoproModel, ExamesTesteSoproTripulanteModel } from "./exames-teste-sopro.model";
import { ExamesTesteSoproService } from './exames-teste-sopro.service';
import { ExamesNaviosService } from '../navios/exames-navios.service';
import { ExamesCargosService } from '../cargos/exames-cargos.service';
import { ExamesDispositivosService } from '../dispositivos/exames-dispositivos.service';
import { ClientesService } from "../../clientes/clientes.service";
import { TiposClientesService } from "../../clientes/tipos-clientes.service";
import { LocaisService } from "../../locais/locais.service";
import { ExamesNaviosModel } from '../navios/exames-navios.model';
import { ExamesCargosModel } from '../cargos/exames-cargos.model';
import { ExamesDispositivosModel } from '../dispositivos/exames-dispositivos.model';
import { Funcoes } from "../../funcoes";
import { Global } from "../../global";

declare let $: any;

@Component({
  selector: 'app-exames-teste-sopro-form',
  templateUrl: './exames-teste-sopro-form.component.html'
})
export class ExamesTesteSoproFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  teste: ExamesTesteSoproModel = new ExamesTesteSoproModel();
  navios: ExamesNaviosModel[] = [];
  cargos: ExamesCargosModel[] = [];
  dispositivos: ExamesDispositivosModel[] = [];
  listClientes: any[] = [];
  listLocais: any[] = [];
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;
  id_teste_sopro: string = null;

  // Abas Fotos e PDF
  listFotos: any[] = [];
  carregandoFotos: boolean = false;
  listPdfs: any[] = [];
  carregandoPdfs: boolean = false;
  urlPdf: string = '';
  comPDF: boolean = false;
  alturaTela: number = 650;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private examesTesteSoproService: ExamesTesteSoproService,
    private examesNaviosService: ExamesNaviosService,
    private examesCargosService: ExamesCargosService,
    private examesDispositivosService: ExamesDispositivosService,
    private clientesService: ClientesService,
    private tiposClientesService: TiposClientesService,
    private locaisService: LocaisService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      id_cliente: [null],
      id_navio: [null],
      id_local: [null],
      id_dispositivo: [null],
      navio_nome: [''],
      navio_imo: [''],
      data_hora_inicio: [''],
      data_hora_fim: [''],
      total_pessoas_testadas: [0],
      master_nome: [''],
      master_data: [''],
      testemunha_nome: [''],
      testemunha_data: [''],
      inspetor_nome: [''],
      inspetor_data: [''],
      pdf: [],
      fotos: []
    });
  }

  ngOnInit() {
    if (this.router.url.split(/\//).pop() == 'upd') {
      this.pageIsUpd = true;
    }

    if (this.router.url.split(/\//).pop() == 'add') {
      this.pageIsAdd = true;
    }

    this.carregarClientes();
    this.carregarNavios();
    this.carregarCargos();
    this.carregarDispositivos();
    this.carregarLocais();

    this.route.params.subscribe(params => {
      var id = params['id_teste'];
      this.id_teste_sopro = id;

      if (!this.pageIsUpd) {
        this.title = this.func.traduzir('front.visualizarTesteSopro');
      } else {
        this.title = id ? this.func.traduzir('front.editarTesteSopro') : this.func.traduzir('front.cadastrarNovoTesteSopro');
      }

      if (this.pageIsAdd) {
        this.title = this.func.traduzir('front.cadastrarNovoTesteSopro');
        this.teste.id_local = '313465793531947206';
        this.form.controls['id_local'].setValue('313465793531947206');
        // Inicializa com 1 tripulante vazio
        if (!this.teste.tripulantes || this.teste.tripulantes.length === 0) {
          this.adicionarTripulante();
        }
      }

      if (!id) {
        return;
      }

      this.carregarFotos();
      this.carregarPdfs();

      if (this.route.snapshot.queryParams["abafotos"] == '1') {
        setTimeout(() => {
          $('a[href="#abafotos"]').tab('show');
        }, 300);
      }

      if (this.route.snapshot.queryParams["abapdf"] == '1') {
        setTimeout(() => {
          $('a[href="#abapdf"]').tab('show');
        }, 300);
      }

      this.examesTesteSoproService.getById(id)
        .subscribe(
          json => {
            let data = json.Payload;
            while (Array.isArray(data) && data.length > 0) {
              data = data[0];
            }
            this.teste = data || new ExamesTesteSoproModel();

            // Patch form controls
            this.form.patchValue({
              id: this.teste.id,
              id_cliente: this.teste.id_cliente,
              id_navio: this.teste.id_navio,
              id_local: this.teste.id_local,
              id_dispositivo: this.teste.id_dispositivo,
              navio_nome: this.teste.navio ? this.teste.navio.nome : this.teste.navio_nome,
              navio_imo: this.teste.navio ? this.teste.navio.imo : this.teste.navio_imo,
              data_hora_inicio: this.teste.data_hora_inicio,
              data_hora_fim: this.teste.data_hora_fim,
              total_pessoas_testadas: this.teste.total_pessoas_testadas,
              master_nome: this.teste.master_nome,
              master_data: this.teste.master_data,
              testemunha_nome: this.teste.testemunha_nome,
              testemunha_data: this.teste.testemunha_data,
              inspetor_nome: this.teste.inspetor_nome,
              inspetor_data: this.teste.inspetor_data
            });

            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarTesteSopro') + ': ' + (this.teste.navio ? this.teste.navio.nome : this.teste.navio_nome);
            } else {
              this.title = this.func.traduzir('front.visualizarTesteSopro') + ': ' + (this.teste.navio ? this.teste.navio.nome : this.teste.navio_nome);
            }

            if (this.teste.tripulantes) {
              this.teste.tripulantes.forEach((t, i) => {
                let controlHorario = 'tripulante_horario_' + i;
                let controlBrac = 'tripulante_brac_' + i;
                if (!this.form.contains(controlHorario)) {
                  this.form.addControl(controlHorario, new FormControl(controlHorario, []));
                }
                if (!this.form.contains(controlBrac)) {
                  this.form.addControl(controlBrac, new FormControl(controlBrac, []));
                }
              });
            }

            if (!this.teste.tripulantes || this.teste.tripulantes.length === 0) {
              if (this.pageIsUpd || this.pageIsAdd) {
                this.adicionarTripulante();
              }
            }

            if (this.teste && this.teste.id_cliente && this.teste.cliente && this.listClientes) {
              let exists = this.listClientes.some(c => String(c.id_cliente) === String(this.teste.id_cliente));
              if (!exists) {
                this.listClientes.unshift(this.teste.cliente);
              }
            }

            if (this.global.debug == true) {
              console.log(data);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  carregarClientes() {
    this.tiposClientesService.get(["clientes"]).subscribe(
      res => {
        let tipos = res.Payload || [];
        let tipoMaritimo = tipos.find(t => String(t.id_tipo) === '8');
        if (tipoMaritimo && tipoMaritimo.clientes && tipoMaritimo.clientes.length > 0) {
          this.listClientes = tipoMaritimo.clientes.sort((a, b) => {
            let nomeA = (a.nome_tratamento || a.nome || '').toLowerCase();
            let nomeB = (b.nome_tratamento || b.nome || '').toLowerCase();
            return nomeA.localeCompare(nomeB);
          });
          if (this.teste && this.teste.id_cliente && this.teste.cliente) {
            let exists = this.listClientes.some(c => String(c.id_cliente) === String(this.teste.id_cliente));
            if (!exists) {
              this.listClientes.unshift(this.teste.cliente);
            }
          }
        } else {
          this.clientesService.get(null, null, ['id_cliente', 'nome_tratamento', 'nome'], { 'tipo_cliente': '8' }).subscribe(
            cRes => {
              this.listClientes = (cRes.Payload || []).sort((a, b) => {
                let nomeA = (a.nome_tratamento || a.nome || '').toLowerCase();
                let nomeB = (b.nome_tratamento || b.nome || '').toLowerCase();
                return nomeA.localeCompare(nomeB);
              });
              if (this.teste && this.teste.id_cliente && this.teste.cliente) {
                let exists = this.listClientes.some(c => String(c.id_cliente) === String(this.teste.id_cliente));
                if (!exists) {
                  this.listClientes.unshift(this.teste.cliente);
                }
              }
            },
            () => {}
          );
        }
      },
      error => {
        this.clientesService.get(null, null, ['id_cliente', 'nome_tratamento', 'nome'], { 'tipo_cliente': '8' }).subscribe(
          cRes => {
            this.listClientes = cRes.Payload || [];
          },
          () => {}
        );
      }
    );
  }

  carregarNavios() {
    this.examesNaviosService.get().subscribe(
      json => {
        this.navios = json.Payload || [];
      },
      error => {}
    );
  }

  carregarCargos() {
    this.examesCargosService.get().subscribe(
      json => {
        this.cargos = json.Payload || [];
      },
      error => {}
    );
  }

  carregarDispositivos() {
    this.examesDispositivosService.get().subscribe(
      json => {
        this.dispositivos = json.Payload || [];
      },
      error => {}
    );
  }

  onDispositivoSelect(idDispositivo) {
    let sel = this.dispositivos.find(d => d.id == idDispositivo);
    if (sel) {
      this.teste.id_dispositivo = sel.id;
      this.form.controls['id_dispositivo'].setValue(sel.id);
    } else {
      this.teste.id_dispositivo = null;
      this.form.controls['id_dispositivo'].setValue(null);
    }
  }

  carregarLocais() {
    this.locaisService.get().subscribe(
      json => {
        this.listLocais = (json.Payload || []).sort((a, b) => {
          let nomeA = (a.nome || '').toLowerCase();
          let nomeB = (b.nome || '').toLowerCase();
          return nomeA.localeCompare(nomeB);
        });
        if (this.pageIsAdd && !this.teste.id_local) {
          this.teste.id_local = '313465793531947206';
          this.form.controls['id_local'].setValue('313465793531947206');
        }
      },
      error => {}
    );
  }

  onNavioSelect(idNavio) {
    let sel = this.navios.find(n => n.id == idNavio);
    if (sel) {
      this.teste.id_navio = sel.id;
      this.teste.navio_nome = sel.nome;
      this.teste.navio_imo = sel.imo;
      this.form.controls['navio_nome'].setValue(sel.nome);
      this.form.controls['navio_imo'].setValue(sel.imo);
    } else {
      this.teste.id_navio = null;
      this.teste.navio_imo = '';
      this.form.controls['navio_imo'].setValue('');
    }
  }

  adicionarTripulante() {
    if (!this.teste.tripulantes) {
      this.teste.tripulantes = [];
    }
    let idx = this.teste.tripulantes.length;
    let controlHorario = 'tripulante_horario_' + idx;
    let controlBrac = 'tripulante_brac_' + idx;
    if (!this.form.contains(controlHorario)) {
      this.form.addControl(controlHorario, new FormControl(controlHorario, []));
    }
    if (!this.form.contains(controlBrac)) {
      this.form.addControl(controlBrac, new FormControl(controlBrac, []));
    }
    let novo = new ExamesTesteSoproTripulanteModel();
    novo.ordem = idx + 1;
    novo.brac = '0.00';
    this.teste.tripulantes.push(novo);
    this.atualizaTotalTripulantes();
  }

  removerTripulante(index: number) {
    if (this.teste.tripulantes && this.teste.tripulantes.length > index) {
      this.teste.tripulantes.splice(index, 1);
      // reordena
      this.teste.tripulantes.forEach((t, i) => {
        t.ordem = i + 1;
      });
      this.atualizaTotalTripulantes();
    }
  }

  onCargoChange(tripulante: ExamesTesteSoproTripulanteModel, idCargo) {
    let cargoSel = this.cargos.find(c => c.id == idCargo);
    if (cargoSel) {
      tripulante.id_cargo = cargoSel.id;
      tripulante.cargo_nome = cargoSel.nome_pt || cargoSel.nome_en || cargoSel.nome_es;
    } else {
      tripulante.id_cargo = null;
    }
  }

  atualizaTotalTripulantes() {
    let total = this.teste.tripulantes ? this.teste.tripulantes.length : 0;
    this.teste.total_pessoas_testadas = total;
    this.form.controls['total_pessoas_testadas'].setValue(total);
  }

  carregarFotos() {
    if (!this.id_teste_sopro) return;
    this.carregandoFotos = true;
    this.examesTesteSoproService.getFotos(this.id_teste_sopro).subscribe(
      res => {
        this.carregandoFotos = false;
        let payload = res.Payload;
        while (Array.isArray(payload) && payload.length === 1 && Array.isArray(payload[0])) {
          payload = payload[0];
        }
        if (Array.isArray(payload)) {
          this.listFotos = payload.filter(item => item && item.id_foto);
        } else {
          this.listFotos = [];
        }
        this.loadVenobox();
      },
      () => {
        this.carregandoFotos = false;
      }
    );
  }

  uploadFotosComplete(resp) {
    try {
      let parsed = typeof resp === 'string' ? JSON.parse(resp) : resp;
      if (parsed && parsed.Success === false) {
        this.func.showErro(parsed);
        this.carregarFotos();
        return;
      }
      let payload = parsed ? parsed.Payload : null;
      if (payload) {
        let items = Array.isArray(payload) ? payload : [payload];
        for (let item of items) {
          if (item && item.id_foto) {
            let exists = this.listFotos.some(f => String(f.id_foto) === String(item.id_foto));
            if (!exists) {
              this.listFotos.push(item);
            }
          }
        }
        this.loadVenobox();
      }
      this.func.showSucesso(this.func.traduzir('back.operacaoRealizadaSucesso'));
    } catch (e) {}
    this.carregarFotos();
  }

  apagaFoto(index: number) {
    let foto = this.listFotos[index];
    if (foto && this.id_teste_sopro) {
      this.examesTesteSoproService.apagarFoto(this.id_teste_sopro, foto.id_foto).subscribe(
        () => {
          this.listFotos.splice(index, 1);
          this.reordenaFotosArray();
          this.func.showSucesso(this.func.traduzir('back.removidoComSucesso'));
        },
        error => {
          this.func.showErro(error.json());
        }
      );
    }
  }

  girarFoto(index: number) {
    let foto = this.listFotos[index];
    if (foto && this.id_teste_sopro) {
      this.examesTesteSoproService.girarFoto(this.id_teste_sopro, foto.id_foto).subscribe(
        () => {
          foto.timestamp = new Date().getTime();
        },
        error => {
          this.func.showErro(error.json());
        }
      );
    }
  }

  ordenouFotos(event) {
    this.reordenaFotosArray();
    let payload = this.listFotos.map(f => ({ id_foto: f.id_foto, ordem: f.ordem }));
    this.examesTesteSoproService.ordenaFotos(this.id_teste_sopro, payload).subscribe();
  }

  reordenaFotosArray() {
    this.listFotos.forEach((f, idx) => {
      f.ordem = idx + 1;
    });
  }

  baixarFotosZip() {
    if (!this.id_teste_sopro) return;
    this.examesTesteSoproService.baixarFotosZip(this.id_teste_sopro).subscribe(
      res => {
        if (res && res.Payload) {
          window.open(this.global.dominio_site + res.Payload, '_blank');
        }
      },
      error => {
        this.func.showErro(error.json());
      }
    );
  }

  loadVenobox() {
    setTimeout(() => {
      if ($('.venobox').length > 0) {
        $('.venobox').venobox();
      }
    }, 500);
  }

  loadTooltip() {
    setTimeout(() => {
      $('[data-popup="tooltip"]').tooltip();
    }, 500);
  }

  // Métodos de PDFs Vinculados
  carregarPdfs() {
    if (!this.id_teste_sopro) return;
    this.carregandoPdfs = true;
    this.examesTesteSoproService.getPdfs(this.id_teste_sopro).subscribe(
      res => {
        this.carregandoPdfs = false;
        let payload = res.Payload;
        while (Array.isArray(payload) && payload.length === 1 && Array.isArray(payload[0])) {
          payload = payload[0];
        }
        if (Array.isArray(payload)) {
          this.listPdfs = payload.filter(item => item && item.id_pdf);
          this.loadTooltip();
        } else {
          this.listPdfs = [];
        }
      },
      () => {
        this.carregandoPdfs = false;
      }
    );
  }

  uploadPdfComplete(resp) {
    try {
      let parsed = typeof resp === 'string' ? JSON.parse(resp) : resp;
      if (parsed && parsed.Success === false) {
        this.func.showErro(parsed);
        this.carregarPdfs();
        return;
      }
      let payload = parsed ? parsed.Payload : null;
      if (payload) {
        let items = Array.isArray(payload) ? payload : [payload];
        for (let item of items) {
          if (item && item.id_pdf) {
            let exists = this.listPdfs.some(p => String(p.id_pdf) === String(item.id_pdf));
            if (!exists) {
              this.listPdfs.push(item);
            }
          }
        }
      }
      this.func.showSucesso(this.func.traduzir('back.operacaoRealizadaSucesso'));
    } catch (e) {}
    this.carregarPdfs();
  }

  apagaPdf(index: number) {
    let pdf = this.listPdfs[index];
    if (pdf && this.id_teste_sopro) {
      this.examesTesteSoproService.apagarPdf(this.id_teste_sopro, pdf.id_pdf).subscribe(
        () => {
          this.listPdfs.splice(index, 1);
          this.reordenaPdfsArray();
          this.func.showSucesso(this.func.traduzir('back.removidoComSucesso'));
        },
        error => {
          this.func.showErro(error.json());
        }
      );
    }
  }

  ordenouPdfs(event) {
    this.reordenaPdfsArray();
    let payload = this.listPdfs.map(p => ({ id_pdf: p.id_pdf, ordem: p.ordem }));
    this.examesTesteSoproService.ordenaPdfs(this.id_teste_sopro, payload).subscribe();
  }

  reordenaPdfsArray() {
    this.listPdfs.forEach((p, idx) => {
      p.ordem = idx + 1;
    });
  }

  visualizarPdf(pdf: any) {
    let url = this.global.dominio_site + '/pdf_teste_sopro/' + (pdf.id_teste || this.id_teste_sopro || this.teste.id) + '/' + pdf.id_pdf + '.pdf';
    window.open(url, '_blank');
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var values = Object.assign({}, this.form.value);

    // Converte dados do modelo
    values.id = this.teste.id;
    values.id_cliente = this.teste.id_cliente;
    values.id_navio = this.teste.id_navio;
    values.id_local = this.teste.id_local;
    values.id_dispositivo = this.teste.id_dispositivo;
    values.navio_nome = (this.teste.navio_nome || '').toUpperCase();
    values.navio_imo = (this.teste.navio_imo || '').toUpperCase();
    values.data_hora_inicio = this.teste.data_hora_inicio;
    values.data_hora_fim = this.teste.data_hora_fim;
    values.master_nome = (this.teste.master_nome || '').toUpperCase();
    values.testemunha_nome = (this.teste.testemunha_nome || '').toUpperCase();
    values.inspetor_nome = (this.teste.inspetor_nome || '').toUpperCase();

    // Tripulantes sanitizados
    if (this.teste.tripulantes) {
      values.tripulantes = this.teste.tripulantes
        .filter(t => t.nome && t.nome.trim() !== '')
        .map((t, idx) => ({
          id: t.id,
          ordem: idx + 1,
          nome: (t.nome || '').toUpperCase(),
          id_cargo: t.id_cargo,
          cargo_nome: t.cargo_nome,
          horario: t.horario,
          brac: t.brac || '0.00'
        }));
    } else {
      values.tripulantes = [];
    }

    values.total_pessoas_testadas = values.tripulantes.length;

    var result;
    if (values.id) {
      result = this.examesTesteSoproService.editar(values, values.id);
    } else {
      result = this.examesTesteSoproService.adicionar(values);
    }

    result.subscribe(
      res => {
        this.enviando = false;
        this.func.showSucesso(this.func.traduzir('back.operacaoRealizadaSucesso'));
        let newId = values.id || (res && res.Payload);
        if (newId && this.pageIsAdd) {
          this.router.navigate(['/painel/exames/teste-sopro', newId, 'upd']);
        } else {
          this.router.navigate(['/painel/exames/teste-sopro']);
        }
      },
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/exames/teste-sopro/exames-teste-sopro-form.component.ts